import React, { lazy, Suspense, useContext } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { SuspenseSpin } from '../shared/styled/spin';

import { AppLayout } from '../modules/layout/containers';
import { IMeContext } from '../modules/me/context/types';
import { MeContext } from '../modules/me/context/context';
import { CounterProvider } from '../modules/counter/context';

// Page Routers
const StatisticsRouter = lazy(() => import('../modules/statistics/router/page.router'));
const LogsRouter = lazy(() => import('../modules/logs/router/page.router'));
const DeclarationsRouter = lazy(() => import('../modules/declarations/router/page.router'));
const FlightsRouter = lazy(() => import('../modules/flights/router/page.router'));
const QuickAcceptRouter = lazy(() => import('../modules/quick-accept/router/page.router'));
const MeRouter = lazy(() => import('../modules/me/router/page.router'));
const CustomsRouter = lazy(() => import('../modules/customs/router/page.router'));
const SupportRouter = lazy(() => import('../modules/support/router/page.router'));
const BasketsRouter = lazy(() => import('../modules/baskets/router/page.router'));
const RefundsRouter = lazy(() => import('../modules/refunds/router/page.router'));
const DeliveryOTPRouter = lazy(() => import('../modules/delivery-otp/router/page.router'));

// Modal Routers
const DeclarationsModalRouter = lazy(() => import('../modules/declarations/router/modal.router'));
const FlightsModalRouter = lazy(() => import('../modules/flights/router/modal.router'));
const QuickAcceptModalRouter = lazy(() => import('../modules/quick-accept/router/modal.router'));
const CustomsModalRouter = lazy(() => import('../modules/customs/router/modal.router'));
const BasketsModalRouter = lazy(() => import('../modules/baskets/router/modal.router'));
const RefundsModalRouter = lazy(() => import('../modules/refunds/router/modal.router'));

export const MainRouter = () => {
  const location = useLocation();
  const { state } = location;
  const me = useContext<IMeContext>(MeContext);

  if (me.state.user.loading) {
    return <SuspenseSpin />;
  }

  if (!me.state.user.data) {
    return (
      <Suspense fallback={<SuspenseSpin />}>
        <Routes>
          <Route path='/' element={<MeRouter />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <CounterProvider>
      <AppLayout>
        <Suspense fallback={<SuspenseSpin />}>
          <Routes location={state?.background || location}>
            <Route path='/statistics' element={<StatisticsRouter />} />
            <Route path='/logs/*' element={<LogsRouter />} />
            <Route path='/declarations/*' element={<DeclarationsRouter />} />
            <Route path='/flights/*' element={<FlightsRouter />} />
            <Route path='/quick_accept/*' element={<QuickAcceptRouter />} />
            <Route path='/customs/dns/*' element={<CustomsRouter />} />
            <Route path='/supports/*' element={<SupportRouter />} />
            <Route path='/delivery-otp/*' element={<DeliveryOTPRouter />} />
            <Route path='/baskets/*' element={<BasketsRouter />} />
            <Route path='/refunds/*' element={<RefundsRouter />} />
            <Route path='*' element={<Navigate to='/declarations/' replace />} />
          </Routes>
          <Routes>
            <Route path='/declarations/*' element={<DeclarationsModalRouter />} />
            <Route path='/flights/*' element={<FlightsModalRouter />} />
            <Route path='/quick_accept/*' element={<QuickAcceptModalRouter />} />
            <Route path='/customs/dns/*' element={<CustomsModalRouter />} />
            <Route path='/baskets/*' element={<BasketsModalRouter />} />
            <Route path='/refunds/*' element={<RefundsModalRouter />} />
          </Routes>
        </Suspense>
      </AppLayout>
    </CounterProvider>
  );
};
